export class FormCompilationType
{
	static REGULAR: string = 'REGULAR';
	static FACEBOOK: string = 'FACEBOOK';
}